import React, { useMemo } from 'react';
import { EXAM_PERIOD_OPTIONS } from './helpers';
import { FormLabel } from './UI-CHAKRA/FormLabel';
import { CustomMenuItem, CustomSelect } from './UI-CHAKRA/Select/CustomSelect';
import { Flex } from './UI-CHAKRA/Flex';

interface SelectExamPeriodProps {
  value: string;
  onChange(val: string): void;
  onBlur?(event: React.FocusEvent<HTMLElement>): void;
  name?: string;
  error?: boolean;
  disabled?: boolean;
  required?: boolean;
}

const SelectExamPeriod = (props: SelectExamPeriodProps) => {
  const { value, onChange, disabled, required } = props;

  const menuItems = useMemo(() => {
    return EXAM_PERIOD_OPTIONS.map((examPeriod, index) => {
      return (
        <CustomMenuItem
          onClick={(value) => {
            onChange(String(value));
          }}
          value={examPeriod}
          label={examPeriod}
          key={index}
        />
      );
    });
  }, [onChange]);

  const label = useMemo(() => {
    return `Quando Realizar${required ? '*' : ''}`;
  }, [required]);

  return (
    <Flex flexDirection={'column'}>
      <FormLabel color={'#868E96'} fontWeight={700}>
        {label}
      </FormLabel>
      <CustomSelect placeholder={'Selecione um período'} value={value} isDisabled={disabled} onBlur={props.onBlur}>
        {menuItems}
      </CustomSelect>
    </Flex>
  );
};

export default React.memo(SelectExamPeriod);
